import { Link } from "react-router-dom";
import type { BoardRow } from "../lib/types";
import { Avatar } from "./Avatar";

export function Board({ rows, format = (v) => String(v), empty = "No one yet." }: { rows: BoardRow[]; format?: (v: number) => string; empty?: string }) {
  if (!rows.length) return <div className="empty">{empty}</div>;
  return <ol className="board">
    {rows.map((r) => <li key={r.user.username} className={r.isMe ? "me" : ""}>
      <span className="rk">{r.rank}</span>
      <Avatar user={r.user} />
      <Link className="who" to={`/u/${r.user.username}`}><b>{r.user.displayName}{r.isMe ? " (you)" : ""}</b>{r.detail && <span>{r.detail}</span>}</Link>
      <span className="val">{format(r.value)}</span>
    </li>)}
  </ol>;
}
